module.exports = __webpack_public_path__ + "media/images/return_cases/inventory-76dda2c762dd57774acc3558531ad610.svg";